var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.effectStartDate)?_c('span',{class:_vm.getEffectStartDateClass},[_vm._v(" "+_vm._s(_vm._f("formatDateToDisplay")(_vm.effectStartDate))+" ")]):_c('span',[_vm._v(" - ")])}
var staticRenderFns = []

export { render, staticRenderFns }